import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigation } from '../data/navigation';

const pathOf = (item) =>
  item.section ? { pathname: item.href, hash: `#${item.section}` } : item.href;

const Nav = () => {
  const location = useLocation();

  const isActive = (item) => {
    if (item.section) {
      return location.pathname === '/' && location.hash === `#${item.section}`;
    }
    if (item.href === '/') {
      return location.pathname === '/' && !location.hash;
    }
    return location.pathname === item.href || location.pathname === `/info${item.href}`;
  };

  return (
    <nav>
      <ul className='flex items-center gap-1'>
        {navigation.map((item) => {
          const active = isActive(item);
          return (
            <li key={item.name}>
              <Link
                to={pathOf(item)}
                className={`px-3 py-2 text-sm font-medium rounded-md whitespace-nowrap ${
                  active ? 'text-accent' : 'text-ink-soft hover:text-accent'
                }`}
              >
                {item.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
